import React,{Component} from 'react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import { renderBySource } from 'common/utils'
import ReportButton from '../../QuestionList/ReportButton';
import { getUserInfo } from 'common/user'
import config from 'config'
import styles from './index.css'

@withRouter
@observer(['answerStore'])
export default class Header extends Component {
  handleClickAskTeacher () {
    const { answerStore } = this.props

    answerStore.toggleAskTeacher(!answerStore.show.askTeacher)
  }

  handleClickPigai () {
    const { answerStore } = this.props

    answerStore.togglePigai(!answerStore.show.pigai)
  }

  handleClickCorrection () {
    const { answerStore } = this.props

    getUserInfo() ?
    answerStore.showCorrection(true) :
    answerStore.toggleLogin(true)
  }

  formatTimeToStr(time) {
    const m = Math.floor(time / 60);
    const s = time % 60;
    return m ? `${m}分${s}秒` : `${s}秒`;
  }

  render () {
    const { answerStore, params, location, status, answerId } = this.props
    const { from } = location.query;
    return (
      <div className={ styles.root }>
        <div className={ styles.wrap }>
          <div className={ styles.title }>{ answerStore.currentReport.name }</div>
          <div className={ styles.right }>
            {
              answerStore.currentReport.canPigai &&
              <div className={styles.time}>
                总耗时：
                {this.formatTimeToStr(answerStore.timeCost)}
              </div>
            }
            {
              ['adaptation', 'smart'].indexOf(from) === -1 && renderBySource(location.query, 'askTeacher', () => (
                <div className={ styles.button } onClick={ () => this.handleClickAskTeacher() }>问问老师</div>
              ))
            }
            {
              renderBySource(location.query, 'pigai', () => {
                const { from, token } = location.query
                const fromParams = from && ['adaptation', 'smart'].indexOf(from) !== -1 ? `&from=${from}&token=${token}&no_header=1&no_footer=1&no_meiqia=1` : ''
                return answerStore.currentReport.canPigai
                  ? <ReportButton status={status} answerId={answerId} exam={params.exam} />
                  : answerStore.list.length > 1
                      ? <a className={ styles.button } href={ `${config.site.zhike}/${params.exam}/report.html?exerciseId=${location.query.exerciseId}${fromParams}` }>返回报告</a>
                      : null
              })
            }
            {
              renderBySource(location.query, 'correction', () => (
                <div className={ styles.correctBtn } onClick={ ()=> this.handleClickCorrection() }>
                  我要纠错
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Answer/Header/index.js
 **/